import { z } from "zod";

export const memberIdSchema = z.object({
  memberId: z.string().min(1, "Member ID number is required."),
});
